import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer
      className="mt-12 bg-gray-900 text-white [&_a]:inline-flex [&_a]:min-h-11 [&_a]:min-w-11 [&_a]:items-center sm:[&_a]:min-h-0 sm:[&_a]:min-w-0"
      role="contentinfo"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {/* About */}
          <div className="col-span-2 md:col-span-3 lg:col-span-1">
            <h3 className="text-xl font-bold mb-4">StageCrew</h3>
            <p className="text-gray-400 text-sm mb-3">
              The AV & stagehand job marketplace. Browse sourced listings, save work preferences,
              and connect employers with relevant crew.
            </p>
            <a href="mailto:edwin@stagecrew.app" className="text-blue-400 hover:text-blue-300 text-sm">
              edwin@stagecrew.app
            </a>
          </div>

          {/* For Workers */}
          <nav aria-label="Worker links">
            <h4 className="text-lg font-bold mb-4">For Workers</h4>
            <ul className="space-y-0 sm:space-y-2">
              <li><Link to="/for-workers" className="text-gray-400 hover:text-white text-sm">How It Works</Link></li>
              <li><Link to="/jobs" className="text-gray-400 hover:text-white text-sm">Browse Gigs</Link></li>
              <li><Link to="/register?role=worker" className="text-gray-400 hover:text-white text-sm">Sign Up Free</Link></li>
              <li><Link to="/pricing" className="text-gray-400 hover:text-white text-sm">Pricing</Link></li>
            </ul>
          </nav>

          {/* For Employers */}
          <nav aria-label="Employer links">
            <h4 className="text-lg font-bold mb-4">For Employers</h4>
            <ul className="space-y-0 sm:space-y-2">
              <li><Link to="/for-employers" className="text-gray-400 hover:text-white text-sm">Why StageCrew</Link></li>
              <li><Link to="/register?role=employer" className="text-gray-400 hover:text-white text-sm">Post a Gig</Link></li>
              <li><Link to="/login" className="text-gray-400 hover:text-white text-sm">Employer Login</Link></li>
              <li><Link to="/for-employers/faq" className="text-gray-400 hover:text-white text-sm">Employer FAQ</Link></li>
              <li><Link to="/claim/vendor-listing" className="text-gray-400 hover:text-white text-sm">Claim Listing</Link></li>
            </ul>
          </nav>

          {/* Crew Roles */}
          <nav aria-label="Crew roles">
            <h4 className="text-lg font-bold mb-4">Crew Roles</h4>
            <ul className="space-y-0 sm:space-y-2">
              <li><Link to="/roles/audio-engineer" className="text-gray-400 hover:text-white text-sm">Audio Engineer</Link></li>
              <li><Link to="/roles/stagehand" className="text-gray-400 hover:text-white text-sm">Stagehand</Link></li>
              <li><Link to="/roles/rigger" className="text-gray-400 hover:text-white text-sm">Rigger</Link></li>
              <li><Link to="/roles/lighting-technician" className="text-gray-400 hover:text-white text-sm">Lighting Tech</Link></li>
              <li><Link to="/roles/video-engineer" className="text-gray-400 hover:text-white text-sm">Video Engineer</Link></li>
              <li><Link to="/roles/stage-manager" className="text-gray-400 hover:text-white text-sm">Stage Manager</Link></li>
            </ul>
          </nav>

          {/* Popular Markets */}
          <nav aria-label="Popular markets">
            <h4 className="text-lg font-bold mb-4">Markets</h4>
            <ul className="space-y-0 sm:space-y-2">
              <li><Link to="/markets/las-vegas" className="text-gray-400 hover:text-white text-sm">Las Vegas</Link></li>
              <li><Link to="/markets/los-angeles" className="text-gray-400 hover:text-white text-sm">Los Angeles</Link></li>
              <li><Link to="/markets/inland-empire" className="text-gray-400 hover:text-white text-sm">Inland Empire</Link></li>
              <li><Link to="/markets/orange-county" className="text-gray-400 hover:text-white text-sm">Orange County</Link></li>
              <li><Link to="/markets/nashville" className="text-gray-400 hover:text-white text-sm">Nashville</Link></li>
              <li><Link to="/markets/chicago" className="text-gray-400 hover:text-white text-sm">Chicago</Link></li>
              <li><Link to="/markets/orlando" className="text-gray-400 hover:text-white text-sm">Orlando</Link></li>
              <li><Link to="/markets/dallas" className="text-gray-400 hover:text-white text-sm">Dallas</Link></li>
              <li><Link to="/gigs/austin" className="text-gray-400 hover:text-white text-sm">Austin</Link></li>
              <li><Link to="/gigs/san-francisco" className="text-gray-400 hover:text-white text-sm">San Francisco</Link></li>
              <li><Link to="/gigs/miami" className="text-gray-400 hover:text-white text-sm">Miami</Link></li>
              <li><Link to="/gigs/denver" className="text-gray-400 hover:text-white text-sm">Denver</Link></li>
            </ul>
          </nav>

          {/* Resources */}
          <nav aria-label="Resources">
            <h4 className="text-lg font-bold mb-4">Resources</h4>
            <ul className="space-y-0 sm:space-y-2">
              <li><Link to="/vendors" className="text-gray-400 hover:text-white text-sm">Vendor Directory</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-white text-sm">Blog</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white text-sm">About Us</Link></li>
              <li><Link to="/help" className="text-gray-400 hover:text-white text-sm">Help & FAQ</Link></li>
              <li><a href="mailto:edwin@stagecrew.app" className="text-gray-400 hover:text-white text-sm">Contact</a></li>
            </ul>
          </nav>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} StageCrew. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/help" className="text-gray-500 hover:text-gray-300">Privacy Policy</Link>
            <Link to="/help" className="text-gray-500 hover:text-gray-300">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
